import React from 'react';
import PropTypes from 'prop-types';
import { invert } from '../utils';
import { Translate } from '../../../../core/translate';
import { Price } from '../Price';

const TotalEmployeeDiscount = ({ pricing }) => {
  const { totalEmployeeDiscount, employeePrice } = pricing;
  if (!employeePrice) {
    return null;
  }

  return (
    <div className="total-discount">
      <div className="incentive__program">
        <div className="incentive__event-name">
          {<Translate value="total.discounts" />}
        </div>
        <Price
          className="employee-discount-price"
          value={invert(totalEmployeeDiscount)}
        />
      </div>
    </div>
  );
};

TotalEmployeeDiscount.propTypes = {
  pricing: PropTypes.object.isRequired,
};

export default TotalEmployeeDiscount;
